// GLOBAL AWS DISABLE FOR OFFSEASON
export const AWS_DISABLED = true;
